import { usePersistStore } from '@/shared/lib/store';
import { useLoginStore } from '@/shared/lib/store/model/login.store';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Modal } from '@/shared/ui';
import { createQueries, useCreateStore } from '@/entities/create';
import { TTOKTTAK_CURRI_YEAR } from '@/shared/constants/constants';

export const Login = () => {
    const router = useRouterState();
    const isDirectCreateSet = router.location.pathname.startsWith('/create-set');

    const loginUrl = import.meta.env.VITE_LOGIN_URL;
    const redirectUrl = import.meta.env.VITE_LOGIN_REDIRECT + '/create'; // 교과서 선택 페이지로 리다이렉트
    // const redirectUrl = import.meta.env.VITE_LOGIN_REDIRECT + router.location.pathname;
    const vivaClass = import.meta.env.VITE_VIVACLASS_DOMAIN;
    const { loginInfo, mLevel, memberInfo, loginCheck, getMemberInfo } = useLoginStore();
    const { sBrandId } = usePersistStore();
    const { setCurribook, setSTextbookList, setInitTextbookList, setSSubjectList } =
        useCreateStore();
    const { showModal, closeModal } = useModalStore();
    const postTextbookSubject = createQueries.textbook.postTextbookSubject();
    const postTextbookListbyCurriBook = createQueries.textbook.postTextbookListbyCurriBook();

    const { setSBrandId } = usePersistStore();

    usePersistStore.getState().printValues();

    useEffect(() => {
        // loginCheck();
        setSBrandId(); // 브랜드 아이디는 비로그인시에도 항상 가져옴
    }, []);

    useEffect(() => {
        // typeCode (0:교사,1:교육전문직원,2:교육대학생,3:일반,4:학생) , level (AU300:정회원,AU400:준회원)
        if (
            memberInfo?.typeCode &&
            !(
                memberInfo.typeCode === '0' ||
                memberInfo.typeCode === '1' ||
                memberInfo.typeCode === '2'
            )
        ) {
            showModal({
                isCustom: true,
                id: 'moal-alert',
                initContents: () => (
                    <Modal
                        open={true}
                        overlay={false}
                        onClose={() => onClose()}
                        title="알림"
                        description={
                            <>
                                스마트 문제은행은
                                <br />
                                교사 인증을 완료한 정회원 대상 서비스입니다.
                                <br />
                                비바샘 사이트에서 교사 인증 후 사용해 주세요!
                            </>
                        }
                        onConfirm={onClose}
                        onConfirmText="확인"
                    ></Modal>
                ),
            });
            return;
        }
        if (mLevel === 'MEMBER_INFO_CONNECTION_FAIL' || mLevel === 'MEMBER_INFO_FAIL') {
            const isConnectionError = mLevel === 'MEMBER_INFO_CONNECTION_FAIL';
            showModal({
                isCustom: true,
                id: 'moal-alert',
                initContents: () => (
                    <Modal
                        open={true}
                        overlay={false}
                        onClose={() => onClose()}
                        title="알림"
                        description={
                            isConnectionError ? (
                                <>
                                    로그인 정보를 확인할 수 없습니다.
                                    <br />
                                    지정된 네트워크에 연결되어 있는지 확인한 후<br />
                                    다시 시도해 주세요.
                                    <br /> <br />
                                    문제가 계속되면 관리자에게 문의해 주세요.
                                </>
                            ) : (
                                <>
                                    스마트 문제은행은
                                    <br />
                                    교사 인증을 완료한 정회원 대상 서비스입니다.
                                    <br />
                                    비바샘 사이트에서 교사 인증 후 사용해 주세요!
                                </>
                            )
                        }
                        onConfirm={onClose}
                        onConfirmText="확인"
                    ></Modal>
                ),
            });
            // setTextbookInfo();
        } else if (!!mLevel && mLevel != 'AU300') {
            showModal({
                isCustom: true,
                id: 'moal-alert',
                initContents: () => (
                    <Modal
                        open={true}
                        overlay={false}
                        onClose={() => onClose()}
                        title="알림"
                        description={
                            <>
                                스마트 문제은행은
                                <br />
                                교사 인증을 완료한 정회원 대상 서비스입니다.
                                <br />
                                비바샘 사이트에서 교사 인증 후 사용해 주세요!
                            </>
                        }
                        onConfirm={onClose}
                        onConfirmText="확인"
                    ></Modal>
                ),
            });
        } else if (!!mLevel && loginInfo.loginYn == 'Y' && mLevel === 'AU300') {
            if (!isDirectCreateSet) setTextbookInfo();
        }
    }, [mLevel]);

    const onClose = () => {
        closeModal('moal-alert');
        window.location.replace(loginUrl);
    };

    const setTextbookInfo = () => {
        let memberGrade = parseInt(memberInfo.myGrade);
        if (loginInfo.schCode === 'ES' && memberGrade !== 3 && memberGrade !== 4) {
            memberGrade = 3;
        }
        const grade = memberGrade ? memberGrade + 9 : 12;

        if (sBrandId !== null)
            postTextbookSubject.mutate(
                {
                    brand_id: sBrandId,
                    type: 'web',
                    curriGrade: loginInfo.schCode === 'ES' ? grade! : 9,
                    curriYear: TTOKTTAK_CURRI_YEAR,
                },
                {
                    onSuccess: (res: API.TextbookSubject.Res | undefined) => {
                        if (res?.vo) {
                            const subjectList = res.vo;
                            setSSubjectList(subjectList);
                            // Todo : 선생님 선택 과목을 우선으로 선택하도록 수정 필요
                            const selectedSubject =
                                subjectList.find(
                                    (subject) => subject.val === memberInfo.mainSubject
                                ) ??
                                subjectList.find((subject) => subject.val === '국어') ??
                                subjectList[0];

                            postTextbookListbyCurriBook.mutate(
                                {
                                    brand_id: sBrandId!,
                                    type: 'web',
                                    curriGrade: loginInfo.schCode === 'ES' ? grade! : undefined,
                                    curriSubject: selectedSubject?.id!,
                                    curriYear: TTOKTTAK_CURRI_YEAR,
                                    curriSchool:
                                        loginInfo.schCode === 'ES'
                                            ? 5
                                            : loginInfo.schCode === 'MS'
                                              ? 6
                                              : loginInfo.schCode === 'HS'
                                                ? 7
                                                : 5,
                                },
                                {
                                    onSuccess: (
                                        res: API.TextbookListbyCurriBook.Res | undefined
                                    ) => {
                                        setInitTextbookList(res?.vo ? res.vo : []);
                                        // setCurribook(res?.vo[0]!);
                                    },
                                }
                            );
                        }
                    },
                }
            );
    };

    return (
        <div className="right">
            {Object.entries(loginInfo).length === 0 ||
            loginInfo.loginYn === 'N' ||
            !(
                memberInfo.typeCode === '0' ||
                memberInfo.typeCode === '1' ||
                memberInfo.typeCode === '2'
            ) ? (
                <ul className="flex_c login_box login">
                    <li>
                        {/* 로그인 버튼에 onClick 핸들러 추가 */}
                        <a href={loginUrl + redirectUrl}>로그인</a>
                    </li>
                    <li>
                        <a href="https://www.vivasam.com/member/join/select">회원가입</a>
                    </li>
                    <li>
                        <a href="https://www.vivasam.com/member/idpw_search">ID/PW찾기</a>
                    </li>
                    <li>
                        <a
                            href="https://www.vivasam.com/support/notice/list"
                            target="_blank"
                            rel="noreferrer"
                        >
                            고객센터
                        </a>
                    </li>
                </ul>
            ) : (
                <ul className="flex_c login_box logout">
                    <li className="user">
                        <strong>{loginInfo.name}</strong> 선생님 안녕하세요.
                    </li>
                    <li>
                        <a
                            href={vivaClass + '/member/logout?goURL=' + redirectUrl}
                            onClick={() => {
                                sessionStorage.removeItem('persist-token');
                            }}
                        >
                            로그아웃
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.vivasam.com/support/notice/list"
                            target="_blank"
                            rel="noreferrer"
                        >
                            고객센터
                        </a>
                    </li>
                </ul>
            )}
        </div>
    );
};
